export const Tabela = [
  {
    value: 'Cliente',
    label: 'Cliente',
  },
  {
    value: 'Contato',
    label: 'Contato',
  },
  {
    value: 'Movimento',
    label: 'Movimento',
  },
  {
    value: 'NotaFiscal',
    label: 'NotaFiscal',
  },
  {
    value: 'Produto',
    label: 'Produto',
  },
  {
    value: 'Botijao',
    label: 'Botijao',
  },
  {
    value: 'Usuario',
    label: 'Usuario',
  },
];
